import React from "react";

const my_skills = [
    {
        id: 0,
        name: "TCP/IP",
        path: "https://media.istockphoto.com/id/1458614660/vector/tcp-ip-transmission-control-protocol-internet-protocol-digital-cloud-vector-illustration.jpg?s=612x612&w=0&k=20&c=7DIt6EsYzzOu8BOUR3o0YGR4X1iulKHRtPXQmxJLt5Y=",
    },
    {
        id: 1,
        name: "Distributed Systems",
        path: "https://cdn-icons-png.flaticon.com/512/17001/17001396.png",
    },
    {
        id: 2,
        name: "Phoenix",
        path: "https://www.phoenixframework.org/images/icon.svg",
    },
    {
        id: 3,
        name: "Golang",
        path: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/go/go-original.svg",
    },
    {
        id: 4,
        name: "Elixir",
        path: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/elixir/elixir-original.svg",
    },
    {
        id: 5,
        name: "Redis",
        path: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/redis/redis-original.svg",
    },
    {
        id: 6,
        name: "RabbitMQ",
        path: "https://upload.wikimedia.org/wikipedia/commons/7/71/RabbitMQ_logo.svg",
    },
    {
        id: 7,
        name: "PostgreSQL",
        path: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg",
    },
    {
        id: 8,
        name: "Docker",
        path: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg",
    },
];

function Skills() {
    // Duplicate the array to create seamless looping
    const scrollingSkills = [...my_skills, ...my_skills, ...my_skills];

    return (
        <div id="skills" className="w-full overflow-hidden py-10 relative">
            <h1 className="text-center font-bold text-3xl mb-10 text-neutral-800">Tech Stack</h1>

            <div className="relative max-w-full overflow-hidden">
                {/* Left gradient fade */}
                <div className="pointer-events-none absolute inset-y-0 left-0 w-16 z-20 bg-gradient-to-r from-purple-200 to-transparent" />

                {/* Right gradient fade */}
                <div className="pointer-events-none absolute inset-y-0 right-0 w-16 z-20 bg-gradient-to-l from-purple-100 to-transparent" />

                {/* Scrolling container */}
                <div className="flex animate-infinite-scroll gap-12 px-4 w-max p-4">
                    {scrollingSkills.map((skill, index) => (
                        <Card key={`${skill.id}-${index}`} skill={skill} />
                    ))}
                </div>
            </div>
        </div>
    );
}

function Card({ skill }) {
    return (
        <div className="w-28 h-28 flex flex-col items-center justify-center bg-white shadow-md rounded-xl transition-all duration-300 hover:scale-110 hover:shadow-lg group cursor-pointer">
            <img
                src={skill.path}
                alt={skill.name}
                className="w-16 h-16 object-contain transition-opacity group-hover:opacity-100 opacity-90"
            />
            <span className="mt-2 text-sm font-medium text-gray-600">{skill.name}</span>
        </div>
    );
}

export default Skills